import React from "react";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useCreateProduct } from "../hooks";
import { ProductForm } from "../components";

export const CreateProduct: React.FC = () => {
  const { form, submit, loading } = useCreateProduct({
    defaultValues: {},
    onCompleted: () => {
      toast.success("Le produit a été créé avec succès");
    },
  });

  return (
    <>
      <Header
        title="Produit"
        subtitle="Créer un nouveau produit"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/products`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouveau produit" />
          <ProductForm loading={loading} submit={submit} form={form} />
        </div>
      </div>
    </>
  );
};
